import { jsx as _jsx } from "react/jsx-runtime";
import { ILayoutElement } from "@faire/web-api--source/indigofair/data/ILayoutElement";
import * as React from "react";
export var LayoutElementRendererData;
(function(LayoutElementRendererData) {
    LayoutElementRendererData.build = function(partial) {
        var _partial_requestId;
        return {
            layoutElement: ILayoutElement.build(partial === null || partial === void 0 ? void 0 : partial.layoutElement),
            requestId: (_partial_requestId = partial === null || partial === void 0 ? void 0 : partial.requestId) !== null && _partial_requestId !== void 0 ? _partial_requestId : "",
            onItemClick: partial === null || partial === void 0 ? void 0 : partial.onItemClick,
            onCTAClick: partial === null || partial === void 0 ? void 0 : partial.onCTAClick,
            onVisible: partial === null || partial === void 0 ? void 0 : partial.onVisible,
            pageType: partial === null || partial === void 0 ? void 0 : partial.pageType
        };
    };
})(LayoutElementRendererData || (LayoutElementRendererData = {}));
export var Context = /*#__PURE__*/ React.createContext(LayoutElementRendererData.build());
export var LayoutElementProvider = function(props) {
    return /*#__PURE__*/ _jsx(Context.Provider, {
        value: props,
        children: props.children
    });
};
